import { SvgIcon } from '@mui/material';
import styles from './ccf-user-plus-icon-component.module.scss';

/* eslint-disable-next-line */
export interface CcfUserPlusIconComponentProps {}

/**
 * component used to display up arrow icon
 * @param props - CcfUpArrowIconProps
 * @example - <CcfUpArrowIcon />
 * @returns SVG of up arrow icon
 */
export function CcfUserPlusIconComponent(props: CcfUserPlusIconComponentProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.50006 3C6.05031 3 4.87506 4.17525 4.87506 5.625C4.87506 7.07475 6.05031 8.25 7.50006 8.25C8.94981 8.25 10.1251 7.07475 10.1251 5.625C10.1251 4.17525 8.94981 3 7.50006 3ZM3.37506 5.625C3.37506 3.34683 5.22189 1.5 7.50006 1.5C9.77824 1.5 11.6251 3.34683 11.6251 5.625C11.6251 7.90318 9.77824 9.75 7.50006 9.75C5.22189 9.75 3.37506 7.90318 3.37506 5.625ZM14.2501 10.5C14.6643 10.5 15.0001 10.8358 15.0001 11.25V12.75H16.5001C16.9143 12.75 17.2501 13.0858 17.2501 13.5C17.2501 13.9142 16.9143 14.25 16.5001 14.25H15.0001V15.75C15.0001 16.1642 14.6643 16.5 14.2501 16.5C13.8358 16.5 13.5001 16.1642 13.5001 15.75V14.25H12.0001C11.5858 14.25 11.2501 13.9142 11.2501 13.5C11.2501 13.0858 11.5858 12.75 12.0001 12.75H13.5001V11.25C13.5001 10.8358 13.8358 10.5 14.2501 10.5ZM5.49476 10.875C5.53756 10.875 5.58099 10.875 5.62507 10.875H9.00006C9.41428 10.875 9.75006 11.2108 9.75006 11.625C9.75006 12.0392 9.41428 12.375 9.00006 12.375H5.62507C4.52382 12.375 4.13947 12.3831 3.84692 12.4719C3.12782 12.69 2.56508 13.2528 2.34695 13.9719C2.2582 14.2644 2.25006 14.6488 2.25006 15.75C2.25006 16.1642 1.91428 16.5 1.50006 16.5C1.08585 16.5 0.750062 16.1642 0.750062 15.75C0.750062 15.7059 0.750046 15.6625 0.750031 15.6197C0.74969 14.6992 0.749457 14.0707 0.911537 13.5364C1.2751 12.3379 2.21299 11.4 3.41149 11.0365C3.94579 10.8744 4.57431 10.8746 5.49476 10.875Z"
          fill="#333333"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfUserPlusIconComponent;
